import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import { MomentDateFormat } from '@s20/common/constants/momentFormats';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../Common';
import { DatePicker } from '../common/forms/DatePicker';

const highlightYearsBack = 1;

/**
 * The payroll "Week Of" / "Period Of" picker. With `highlightPeriodStarts` it highlights the first day of every pay
 * period of the last year, as the server resolves them (GET payrolls/payPeriodStarts), so the pay calendar rule lives
 * only on the server. A misconfigured calendar is reported by the ResolvedPayPeriodHint shown under the picker, so an
 * error here simply leaves the calendar unhighlighted and is not retried.
 */
export const PayPeriodDatePicker = ({ highlightPeriodStarts = false, ...pickerProps }) => {
    const to = moment().format(MomentDateFormat.DateOnlyUTCHyphenated);
    const from = moment().subtract(highlightYearsBack, 'year').format(MomentDateFormat.DateOnlyUTCHyphenated);

    const { data: periodStarts } = useQuery({
        queryKey: ['payPeriodStarts', from, to],
        queryFn: () => httpClient.js(ApiRoutes.payroll.payPeriodStarts(from, to)),
        enabled: highlightPeriodStarts,
        retry: false,
    });

    return (
        <DatePicker
            highlightDates={(periodStarts ?? []).map((start) => moment(start).toDate())}
            {...pickerProps}
        />
    );
};
